import AppRoutes from "@/routes/index"
import React from "react"
import { Toaster } from "sonner"
import { HelmetProvider } from "react-helmet-async"
import ErrorBoundary from "@/core/error-pages/ErrorBoundary"

import "@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css"
import "react-calendar/dist/Calendar.css"
import "react-clock/dist/Clock.css"
import "react-datetime-picker/dist/DateTimePicker.css"

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Toaster
        className="custom-toast"
        closeButton
        position="top-center"
        toastOptions={{
          className: "custom-toast",
          style: {
            borderRadius: "8px",
            boxShadow: "0 8px 16px rgba(145, 158, 171, 0.16)",
            color: "#212B36",
            display: "flex",
            gap: "1rem",
            padding: "12px",
          },
        }}
      />
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </HelmetProvider>
  )
}

export default App
